/**
 * SDK 자동 생성 멱등키. `${eventName}-${random16bytesHex}` 형식.
 *
 * 브라우저 `crypto.getRandomValues`를 강제한다. (모든 타깃 브라우저에서 지원)
 * Math.random 폴백을 두지 않는 이유: 멱등키 충돌 시 같은 사용자의 이벤트가
 * 합쳐지거나 한쪽이 폐기될 수 있어, 잘못된 randomness는 침묵하기보다 명시적으로 실패해야 한다.
 */
const toHex = (bytes: Uint8Array): string => Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('')

const randomBytes16 = (): Uint8Array => {
  if (typeof crypto === 'undefined' || typeof crypto.getRandomValues !== 'function') {
    throw new Error('@edgelinkapp/sdk-web: crypto.getRandomValues is required')
  }
  const bytes = new Uint8Array(16)
  crypto.getRandomValues(bytes)
  return bytes
}

const generateExternalEventId = (eventName: string): string => `${eventName}-${toHex(randomBytes16())}`

export { generateExternalEventId }
